import Button from "../Button";
import Chevron from "@/assets/icons/chevron.svg?react";
import AppHandIcon from "@/assets/icons/app-hand.svg?react";
import BPMonitorIcon from "@/assets/icons/bp-monitor.svg?react";
import ReferralIcon from "@/assets/icons/referral-sheet.svg?react";
import GraphIcon from "@/assets/icons/measurements-graph.svg?react";
import { StepProps } from "@/data/onboarding/types";
import styles from "./Step.module.scss";

export default function MotivationStepExistingTreatment({
  onAnswer,
}: StepProps) {
  return (
    <div>
      <p className="text-center">
        Vi hjälper över 22 000 patienter att hålla koll på sitt blodtryck
      </p>

      <div className="fw-500 font-17">
        <div className="flex gap-10 align-center">
          <AppHandIcon />
          <span>
            Regelbunden uppföljning med läkare och sjuksköterska, helt digitalt
          </span>
        </div>
        <div className="flex gap-10 align-center">
          <ReferralIcon />
          <span>Årlig provtagning ingår kostnadsfritt</span>
        </div>
        <div className="flex gap-10 align-center">
          <BPMonitorIcon />
          <span>Uppkopplad blodtrycksmätare lånar du gratis av oss</span>
        </div>
        <div className="flex gap-10 align-center">
          <GraphIcon />
          <span>Dina mätningar sparas i appen automatiskt</span>
        </div>
      </div>

      <div className={styles.formAction}>
        <Button onClick={() => onAnswer()} iconRight={<Chevron />}>
          Fortsätt
        </Button>
      </div>
    </div>
  );
}
